import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { KeyRound, LockKeyhole } from "lucide-react";
import { AuthField, AuthSplitLayout } from "@/components/AuthSplitLayout";
import { api, formatApiError } from "@/lib/api";

export default function AcceptProviderInvitePage() {
  const [params] = useSearchParams();
  const tokenFromLink = params.get("token") || "";
  const [token, setToken] = useState(tokenFromLink);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  async function submit(event) {
    event.preventDefault();
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setIsSaving(true);
    try {
      await api.post("/providers/invites/accept", { token, password });
      window.location.assign("/provider-portal");
    } catch (requestError) {
      setError(formatApiError(requestError));
      setIsSaving(false);
    }
  }

  return (
    <AuthSplitLayout
      testId="provider-invite-accept-page"
      statement="Activate your TAG provider workspace."
      support="Your placements, assignment confirmations, evaluations and weekly notes — all in your Provider Portal."
      heading="Set your password"
      description="Create a password to activate your provider account. At least 8 characters."
    >
      <form className="login-form" onSubmit={submit}>
        {!tokenFromLink && (
          <AuthField id="invite-token" label="Invitation token" icon={KeyRound}>
            <input
              data-testid="provider-invite-token-input"
              id="invite-token"
              placeholder="Paste the token from your invitation"
              value={token}
              onChange={(event) => setToken(event.target.value)}
              required
            />
          </AuthField>
        )}
        <AuthField id="password" label="Password" icon={LockKeyhole}>
          <input
            data-testid="provider-invite-password-input"
            id="password"
            type="password"
            placeholder="At least 8 characters"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
            minLength="8"
            autoComplete="new-password"
          />
        </AuthField>
        <AuthField id="confirm-password" label="Confirm password" icon={LockKeyhole}>
          <input
            data-testid="provider-invite-confirm-password-input"
            id="confirm-password"
            type="password"
            placeholder="Repeat your password"
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            required
            minLength="8"
            autoComplete="new-password"
          />
        </AuthField>
        {error && (
          <p className="form-message error-message" data-testid="provider-invite-error">{error}</p>
        )}
        <button className="login-submit" data-testid="provider-invite-accept-button" disabled={isSaving} type="submit">
          {isSaving ? "Activating…" : "Activate provider account"}
        </button>
      </form>
    </AuthSplitLayout>
  );
}
